// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Export = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Export = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Export = _exports.Export = function Export(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.045 16.2975C13.7608 16.6858 13.2558 16.875 12.5 16.875H5C3.68583 16.875 3.125 16.3142 3.125 15V5C3.125 3.68583 3.68583 3.125 5 3.125H9.375V5C9.375 7.015 10.485 8.125 12.5 8.125H14.375V10C14.375 10.345 14.655 10.625 15 10.625C15.345 10.625 15.625 10.345 15.625 10V7.5C15.625 7.33417 15.5592 7.175 15.4417 7.05833L10.4417 2.05833C10.3242 1.94083 10.1658 1.875 10 1.875H5C2.985 1.875 1.875 2.985 1.875 5V15C1.875 17.015 2.985 18.125 5 18.125H12.5C13.6658 18.125 14.5258 17.7592 15.0541 17.0358C15.2575 16.7575 15.1976 16.3667 14.9192 16.1625C14.6392 15.9575 14.2492 16.02 14.045 16.2975ZM10.625 5V4.00917L13.4908 6.875H12.5C11.1858 6.875 10.625 6.31417 10.625 5ZM18.775 13.775L17.1084 15.4417C16.9867 15.5633 16.8267 15.625 16.6667 15.625C16.5067 15.625 16.3466 15.5642 16.225 15.4417C15.9808 15.1975 15.9808 14.8017 16.225 14.5575L16.825 13.9575H10.8333C10.4883 13.9575 10.2083 13.6775 10.2083 13.3325C10.2083 12.9875 10.4883 12.7075 10.8333 12.7075H16.8241L16.2242 12.1075C15.98 11.8633 15.98 11.4675 16.2242 11.2233C16.4683 10.9792 16.8642 10.9792 17.1084 11.2233L18.775 12.89C18.8325 12.9475 18.8782 13.0167 18.9099 13.0933C18.9732 13.2458 18.9732 13.4183 18.9099 13.5708C18.8782 13.6483 18.8325 13.7175 18.775 13.775Z",
      fill: "#212B36"
    }));
  };
});
